import { Inject } from '@angular/core';
import '@angular/compiler';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { PageWikiTaxonomyDesignComponent } from './page.wiki.taxonomy.design/page.wiki.taxonomy.design.component';
import { PageDocsDraftComponent } from './page.docs.draft/page.docs.draft.component';
import { PageBenchmarksLlmDetailComponent } from './page.benchmarks.llm.detail/page.benchmarks.llm.detail.component';
import { PageMainTopicComponent } from './page.main.topic/page.main.topic.component';
import { PageMainComponent } from './page.main/page.main.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PageReportComponent } from './page.report/page.report.component';
import { PageFrameworksCavemanComponent } from './page.frameworks.caveman/page.frameworks.caveman.component';
import { PageMembersComponent } from './page.members/page.members.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PageCodexSkillsComponent } from './page.codex.skills/page.codex.skills.component';
import { PageLlmTaxonomyComponent } from './page.llm.taxonomy/page.llm.taxonomy.component';
import { PageCodexGoalComponent } from './page.codex.goal/page.codex.goal.component';
import { PageSearchComponent } from './page.search/page.search.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PageBenchmarksLlmComponent } from './page.benchmarks.llm/page.benchmarks.llm.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PageDashboardComponent } from './page.dashboard/page.dashboard.component';
import { PagePostsComponent } from './page.posts/page.posts.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PagePostsItemComponent } from './page.posts.item/page.posts.item.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, COMPOSITION_BUFFER_MODE } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NuMonacoEditorModule } from '@ng-util/monaco-editor';
import { SortablejsModule } from "src/libs/portal/season/ngx-sortablejs";
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
    constructor(@Inject( DomSanitizer) private domSanitizer: DomSanitizer) { }
    transform(url) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
}

// translate libs
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { HttpClient, HttpClientModule } from '@angular/common/http';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/lang/', '.json');
}

// initialize ng module
@NgModule({
    declarations: [
        SafePipe,
        AppComponent,
        PageMypageComponent,
        PageWikiTaxonomyDesignComponent,
        PageDocsDraftComponent,
        PageBenchmarksLlmDetailComponent,
        PageMainTopicComponent,
        PageMainComponent,
        PortalSeasonTreeComponent,
        PageReportComponent,
        PageFrameworksCavemanComponent,
        PageMembersComponent,
        LayoutEmptyComponent,
        PageCodexSkillsComponent,
        PageLlmTaxonomyComponent,
        PageCodexGoalComponent,
        PageSearchComponent,
        PortalSeasonPaginationComponent,
        PortalSeasonLoadingDefaultComponent,
        PageBenchmarksLlmComponent,
        PortalSeasonLoadingSeasonComponent,
        PageDashboardComponent,
        PagePostsComponent,
        PortalSeasonModalComponent,
        PagePostsItemComponent,
        PortalSeasonFormDropdownComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        SortablejsModule,
        KeyboardShortcutsModule.forRoot(),
        NuMonacoEditorModule.forRoot({ baseUrl: `lib` }),
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            defaultLanguage: 'en'
        }),
        
    ],
    providers: [
        {
            provide: COMPOSITION_BUFFER_MODE,
            useValue: false
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }